<div class="outerLoadingContainer">
  <div class="loadingContainer">
    <div class="marker"></div>
    <div class="marker" style="animation-delay: .05s"></div>
    <div class="marker" style="animation-delay: .1s"></div>
  </div>
</div>
